export default function MySQL_INSERTSELECT() {
  return (
    <div>
      <h2>MySQL_INSERTSELECT</h2>    </div>
  );
}